import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgIllnessRash = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.8 10.8v-7a1.4 1.4 0 1 1 2.8 0"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.8 8.7a1.4 1.4 0 0 0-2.8 0v5.453a4.2 4.2 0 0 0 1.867 3.494l1.707 1.133a1.4 1.4 0 0 1 .623 1.165V22M10.6 7.3V2.4a1.4 1.4 0 1 1 2.8 0v4.9"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4 3.1a1.4 1.4 0 1 1 2.8 0v2.1"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2 8V5.2a1.4 1.4 0 1 1 2.8 0v10.909c0 .651-.15 1.294-.44 1.878l-.809 1.617a1.398 1.398 0 0 0-.147.626V22"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9 13.06a.35.35 0 1 1-.7 0M15.9 13.06a.35.35 0 1 0-.7 0M12.167 15.817a.35.35 0 1 1-.7 0M12.167 15.817a.35.35 0 1 0-.7 0M11.234 11.086a.35.35 0 1 1-.7 0M11.234 11.086a.35.35 0 1 0-.7 0M14.034 20.483a.35.35 0 1 1-.7 0M14.034 20.483a.35.35 0 1 0-.7 0"
          stroke="currentColor"
          strokeWidth={1.25}
        />
      </svg>
    </IconBase>
  );
};

SvgIllnessRash.displayName = 'SvgIllnessRash';
export default SvgIllnessRash;
